import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface IImage {
    src: string;
    height?: string;
    width?: string;
    alt?: string;
    caption?: HTMLElement | any;
    parentClass?: string;
    className?: string;
    routerLink?: any;
    children?: ReactNode;
}

const LazyImage = ({
    src,
    height = 'auto',
    width = '100%',
    alt = '',
    caption = <></>,
    className = '',
    parentClass = '',
    routerLink,
    children,
}: IImage) => {
    const navigate = useNavigate();
    const handleClick = () => {
        if (routerLink) navigate(routerLink);
    };

    return (
        <div className={parentClass}>
            <img
                onClick={handleClick}
                alt={alt}
                height={height}
                src={src} // use normal <img> attributes as props
                width={width}
                loading="lazy"
                className={`${className} ${routerLink ? 'cursor-pointer' : ''}`}
            />
            {caption}
            {children}
        </div>
    );
};

export default LazyImage;
